<template>
<div style="position: fixed;">
    <van-nav-bar safe-area-inset-top
      title="选择车色号"
      fixed
    />
    <div class="box">
    
    <!-- <div class="box-back"></div> -->
    <div class="box1">
        <van-field
        v-model="dataPar.carBrandName"
        is-link
        readonly
        label="汽车品牌"
        @click="openCarBrandModel"
        />
         <van-popup class="popup-style" v-model="carBrandShow" round position="bottom">
            <div class="cascader-input-style">
              <!-- <input v-model="carBrandValue" class="stepper-div-btn" placeholder="查询汽车品牌" type="text"> -->
              <van-field
                left-icon="search"
                type="search"
                v-model="carBrandValue"
                class="stepper-div-btn"
                placeholder='查询汽车品牌'
              />
            </div>
          <van-cascader
              v-model="selectedBrandValue"
              title="请选择汽车品牌"
              active-color="#1989fa"
              :options="filterCarBrand"
              
              @close="closeClick"
              @finish="onCarBrandFinish"
              
          >
          <!-- @change="optionsChange(e,'carBrand')" -->
        </van-cascader>
      </van-popup>
        <van-field
        v-model="dataPar.carModelName"
        is-link
        readonly
        label="车型"
        @click="clickCarModel"
        />
        <van-popup class="popup-style" v-model="carModelShow" round position="bottom">
            <div class="cascader-input-style">
              <!-- <input v-model="carModelValue" class="stepper-div-btn" placeholder="查询车型" type="text"> -->
              <van-field
                left-icon="search"
                type="search"
                v-model="carModelValue"
                class="stepper-div-btn"
                placeholder='查询车型'
              />
            </div>
            <!-- <a-cascader
              :options="options"
              :showSearch="{filter}"
              @change="onChange"
              placeholder="输入shang试试看"
              style="width:330px"
            /> -->
        <van-cascader
            v-model="selectedModelValue"
            title="请选择车型"
            active-color="#1989fa"
            :options="filterCarModel"
            @close="closeClick"
            @finish="onCarModelFinish"
            
        >
        </van-cascader>
        </van-popup>
        
        <van-field
        v-model="fieldValue1"
        custom-style="-webkit-text-fill-color:rgb(130 127 127 / 83%); "
        is-link
        readonly
        label="车色号"
        @click="colorSizeClick"
        />

        <van-action-sheet v-model="vehiclePopup" :close="closeModel" title="车型">
          <van-cell-group>
            <van-field
                label-width="7em"
                required
                v-model="Rest.brandName"
                :readonly="dataPar.carBrandCode!=''"
                label="汽车品牌"
                placeholder="请输入汽车品牌名称"
              />
              <van-field
                required
                label-width="7em"
                v-model="Rest.modelName"
                label="车型"
                placeholder="请输入车型"
              />
          </van-cell-group>
          <div class="model-btn">
              <van-button @click="affClick('type1')" size="small" round type="info">确认</van-button>
          </div>
        </van-action-sheet>
        <van-popup class="popup-style" v-model="show1" round position="bottom">
            <div class="cascader-input-style">
              <van-field
                left-icon="search"
                type="search"
                v-model="iptValue"
                class="stepper-div-btn"
                placeholder='查询车色号'
              />
            </div>
            <van-cascader
                v-model="cascaderValue1"
                title="请选择车色号"
                active-color="#1989fa"
                :options="searchResult"
                @close="closeClick"
                @finish="onFinish1"
                @change="optionsChange1"
            >
            </van-cascader>
        </van-popup>
        <van-action-sheet v-model="colorPopup" :close="closeModel" title="车色号">
          <van-cell-group>
            <van-field
                label-width="7em"
                required
                v-model="RestCor.ColorName"
                label="车色名称"
                placeholder="请输入车色名称"
              />
              <van-field
                label-width="7em"
                v-model="RestCor.ColorCode"
                label="车色号代码"
                placeholder="请输入车色号代码(非必填)"
              />
          </van-cell-group>
          <div class="model-btn">
              <van-button @click="affClick('type2')" size="small" round type="info">确认</van-button>
          </div>
        </van-action-sheet>
        <van-cell title="油漆品牌" />
        <van-popup>
          <van-cell-group >
            
          </van-cell-group>
          <div class="vehiclePopupBox">
            
            <van-row style="margin-top:30px;padding-bottom: 20px;">
                <van-col span='2'></van-col>
                <van-col span='20'>
                    <van-button @click="affClick('type1')" type="primary" block>确认</van-button>
                </van-col>
                <van-col span='1'></van-col>
            </van-row>
          </div>
        </van-popup>
        <van-row>
            <van-col span='1'></van-col>
            <van-col span='22'>
                <div class="col-div">
                    <div v-for="(item,index) in paintArr" :key="index" @click="colCick(item)" :style="dataPar.paintColorName === item.brandName ? 'color:rgb(0,132,184);border: solid 1px rgb(204,230,241);background-color:rgb(204,230,241);':''" class="div-cell">
                        <span style="font-size:13px;">{{item.brandName}}</span>
                    </div>
                </div>
            </van-col>
            <van-col span='1'></van-col>
        </van-row>
    </div>
    <div class="box-btn">
        <van-button @click="routeClick" round type="info">下一步</van-button>
    </div>
    <Tabbar class="tab-style"  :key="datekey" ></Tabbar>  
  </div>
  <van-dialog v-model="dialogShow" title="提示" showConfirmButton showCancelButton confirm-button-color="#1989fa" @confirm="confirmOpen" @cancel="cancelOpen">
    <div style="text-align:center;padding-top:10px;padding-bottom:10px;font-size:13px;" >
      {{dialogPrompt}}
    </div>
  </van-dialog>
</div>

</template>

<script>
import { Toast  } from 'vant';
import Api from "../../api/api";
// 引入pinia
import {mapState} from 'pinia'
import storeState from '../../store/index'  //storeId就是导出的那个值
import Tabbar from "../../components/Tabbar.vue";

const storeStates = storeState()

export default {
  data() {
    return {
      iptValue:'', // 查询车色号值
      vehiclePopup: false, // 车型值
      colorPopup: false, // 车色号值
      show: false, // 控制显示隐藏
      fieldValue: '',  // 车色号输入框值
      cascaderValue: '', // 请选择车色号值
      datekey:Date.now(),  //，单独刷新 底部选择tab
      dialogPrompt: "", //弹框提示语
      dialogShow:false, //弹框显示
      customColorInfo:null, //色号信息
      customModelInfo:null, //车型信息
      customBrandInfo:null, //品牌信息
      customType:'', //校验类型
      activated(){
        if(!this.$route.meta.isBack || this.isFirstEnter){
        // 如果isBack是false，表明需要获取新数据，否则就不再请求，直接使用缓存的数据
        // 如果isFirstEnter是true，表明是第一次进入此页面或用户刷新了页面，需获取新数据
        this.refreshing=true;
        this.listType='10361001';
        this.searchKey='';
        this.resBrandType=10351001;
        this.onLoad();
        }
    
        this.$route.meta.isBack=false
        this.isFirstEnter=false;
        this.datekey = Date.now();//这里更新了datekey ，组件就会刷新
     },
      carBrandShow: false, // 汽车品牌弹框显示
      carModelShow: false, // 车型弹框显示

      carBrandValue: "", // 查询汽车品牌输入框值
      carModelValue: "", // 查询车型输入框值
      selectedBrandValue: "", // 请选择汽车品牌值
      selectedModelValue: "", // 请选择车型值
      // 汽车品牌选项列表，children 代表子选项，支持多级嵌套
      carBrandOptions: [
      ],
      // 车型选项列表，children 代表子选项，支持多级嵌套
      carModelOptions: [
      ],
      show1: false, // 查询车色号弹框
      carBrandFieldValue: "", // 品牌选择值
      carModelFieldValue: "", // 车型选择值
      fieldValue1: '', // 车色号输入框值
      cascaderValue1: '', // 请选择车色号值
      // 选项列表，children 代表子选项，支持多级嵌套
      options1: [],
      paintArr: [], // 油漆品牌列表
      // 废弃值
      dataQuery: {
        brandName: '',
        brandCode: '',
        colorNum: '',
        brandPaintName: '',
        brandPaintCode: '',
      },
      // 选择其他时的值
      datas:{
        brandCode:''
      },
      // 新增配方入参
      dataPar:{
        
        vehicle:'',
        colorNum: '',// 色号
       
        paintColor: '', // 品牌code
        paintColorName: "", // 品牌名称
        brandUrl: '', // 油漆品牌url

        gdModelId: '',  // 车型ID
        carModelCode: '', // 车型代码
        carModelName: '', // 车型名称
        oemCode:'',
        carBrandCode: '', // 品牌代码
        carBrandName: '', // 品牌名称

        gdColorId: '', // 颜色ID
        colorCode: '', // 车色号代码
        colorName: '', // 车色名称
        colorRgb: '', // 色号RGB
      },
      // 车型信息记录
      Rest: {
        brandName: "",
        modelName: "",
      },
      // 色号信息记录
      RestCor: {
        ColorName: "",
        ColorCode: "",
      },
      // 品牌数据
      ppData: null,
      collectionRecipe: null,
    };
  },
  computed: {
    ...mapState(storeState,['addColor']),
    // 颜色搜索
    searchResult() {
      let price = this.options1.filter((item) => {
          return item.text.toLowerCase().includes(this.iptValue.toLowerCase());
      });
      if (price.length === 0) {
        // this.iptValue = '其他';
        return this.options1.filter((item) => {
          if(item.text == '其他'){
            return true;
          } else {
            return item.text.toLowerCase().includes(this.iptValue.toLowerCase());
          } 
        });
      }
      return price;
    },
    // 品牌搜索
    filterCarBrand() {
      let price = this.carBrandOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carBrandValue.toLowerCase());
      });
      if (price.length === 0) {
        // this.carBrandValue = '其他';
        return this.carBrandOptions.filter((item) => {
          if(item.text == '其他'){
            return true;
          } else {
            return item.text.toLowerCase().includes(this.carBrandValue.toLowerCase());
          } 
        });
      }
      return price;
    },
    // 车型
    filterCarModel() {
      let price = this.carModelOptions.filter((item) => {
          return item.text.toLowerCase().includes(this.carModelValue.toLowerCase());
      });
      if (price.length === 0) {
        // this.carModelValue = '其他';
        return this.carModelOptions.filter((item) => {
          if(item.text == '其他'){
            return true;
          } else {
            return item.text.toLowerCase().includes(this.carModelValue.toLowerCase());
          } 
        });
      }
      return price;
    }
  },
  components: { 
        Tabbar,
    },
  async created(){
    console.log('storeStates.addColor',storeStates.addColor);
    
    this.dataPar= storeStates.addColor?storeStates.addColor:this.dataPar;
    console.log('storeStates.collectionRecipeItem',storeStates.collectionRecipeItem);
    storeStates.colorData = null;
    storeStates.colorDataArrs = null;
    //征集配方处理
    if(storeStates.collectionRecipeItem){
      this.collectionRecipe=storeStates.collectionRecipeItem;
      this.dataPar.paintColor=storeStates.collectionRecipeItem.paintBrandCodeStr;
      this.dataPar.paintColorName=storeStates.collectionRecipeItem.paintBrandName;
      this.dataPar.brandUrl = storeStates.collectionRecipeItem.paintBrandUrl;
      this.dataPar.oemCode=storeStates.collectionRecipeItem.oemId;
      this.dataPar.carBrandCode=storeStates.collectionRecipeItem.carBrandId;
      this.dataPar.carBrandName=storeStates.collectionRecipeItem.carBrandName;
      this.dataPar.gdModelId=storeStates.collectionRecipeItem.carModelId;
      this.dataPar.collectionGdModelId=storeStates.collectionRecipeItem.carModelId;
      this.dataPar.carModelName=storeStates.collectionRecipeItem.carModelName;
      this.dataPar.gdColorId=storeStates.collectionRecipeItem.colorCodeId;
      this.dataPar.colorCode=storeStates.collectionRecipeItem.colorCode;
      this.dataPar.colorName=storeStates.collectionRecipeItem.colorName;
      this.dataPar.collectRegion=storeStates.collectionRecipeItem.collectRegion;
      this.dataPar.collectRegionName=storeStates.collectionRecipeItem.collectRegionName;
      this.dataPar.recipeCollectId=storeStates.collectionRecipeItem.collectionId;

      this.RestCor.ColorName = this.dataPar.colorName;
      this.RestCor.ColorCode = this.dataPar.colorCode;

      if(this.dataPar.colorName||this.dataPar.colorCode){
        this.dataPar.colorNum = (this.dataPar.colorCode?this.dataPar.colorCode:"")+' '+ (this.dataPar.colorName?this.dataPar.colorName:"");
      }

      storeStates.collectionRecipeItem=null;
    }
    // 汽车品牌
    await Api.vehicleList({}).then((res) => {
      let brandArr = [];
        console.log("品牌",res);
        // 遍历所有品牌，改变成可用的数据
        for (let index = 0; index < res.data.result.length; index++) {
          let obj = {text:'',value: '',oemCode: ''}
          obj.text = res.data.result[index].brandName;
          obj.value = res.data.result[index].brandCode;
          obj.oemCode = res.data.result[index].oemCode;
          brandArr.push(obj)
          // 去掉其他
          if (res.data.result.length === index+1) {
            let obj = {text:'其他',value: '',oemCode: '其他'}
            brandArr.push(obj)
          }
        }
        this.carBrandValue = '';
        console.log("for",brandArr);
        this.carBrandOptions = brandArr;
    })
    // 油漆品牌
    await Api.paintBrand().then((res) => {
      console.log("油漆品牌",res);
      this.paintArr = res.data.result;
      // this.dataPar.paintColorName = res.data.result[0].brandName;
      // this.dataPar.paintColor = res.data.result[0].brandCode;
      // this.dataPar.brandUrl = res.data.result[0].brandUrl;
    })
    
    if(this.dataPar.carBrandName){
      this.Rest.brandName = this.dataPar.carBrandName;
      this.queryVehicleModelList(this.dataPar.carBrandName);
    }
   
    if(this.dataPar.oemCode){
      this.fieldValue1=this.dataPar.colorNum;
      await this.queryColorNumList(this.dataPar.oemCode);
    }
  },
  watch: {
    fieldValue(newVal) {
      let value = newVal.split('/')[1];
      if (value === '其他') {
        this.fieldValue = ''
      }
    },
    fieldValue1(newVal) {
      if (newVal === '其他') {
        this.fieldValue1 = ''
      }
    },
  },
  methods: {
    // 全部选项选择完毕后，会触发 finish 事件
    async onCarBrandFinish({selectedOptions}) {
      this.fieldValue1 = '';
      this.cascaderValue1 = '';
      this.carBrandShow = false;
      console.log("品牌",selectedOptions);
      
      // this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      // this.dataPar.vehicle = this.fieldValue;
      // console.log("pp",this.fieldValue);
      // let pps = {brandCode:pp}
      this.selectedBrandValue = selectedOptions[0].value;
      this.carBrandFieldValue=selectedOptions[0].text;
      
      this.carModelFieldValue="";
      if(selectedOptions[0].text=="其他"){
        this.dataPar.oemCode="";
        this.dataPar.carBrandCode="";
        this.dataPar.carBrandName="";
        this.dataPar.carModelName="";

        this.dataPar.gdModelId="";
        this.dataPar.carModelCode="";
        this.dataPar.carModelName="";

        this.fieldValue1="";
        this.dataPar.gdColorId = "";
        this.dataPar.colorRgb = "";
        this.dataPar.colorCode = "";
        this.dataPar.colorName = "";
       
        this.Rest.brandName = this.dataPar.carBrandName;
        this.Rest.modelName = "";

        this.vehiclePopup = true; 
        // 去掉其他
        this.carModelOptions=[{text:'其他',value: '',}];
        this.options1=[{text:'其他',value: '',}];
        return;
      }

      this.dataPar.oemCode=selectedOptions[0].oemCode;
      this.dataPar.carBrandCode=selectedOptions[0].value;
      this.dataPar.carBrandName=selectedOptions[0].text;

      this.dataPar.gdModelId="";
      this.dataPar.carModelCode="";
      this.dataPar.carModelName="";

      await this.queryVehicleModelList(selectedOptions[0].text);
      
      console.log("色号1",this.options1);
      console.log('总数居dataPar',this.dataPar);
    },
    openCarBrandModel() {
      if(this.dataPar.recipeCollectId){
        console.log("征集配方品牌不允许选择");
        return false;
      }
      this.carBrandShow = true;
    },
    async queryVehicleModelList(brandName){
      let parmas = {
        brandName:brandName
      }

       // 响应结果改造
      let arrQ = []
      // 根据品牌,获取车型列表
      await Api.vehicleModelList(parmas).then((res) => {
        console.log("车型1",res);
        // 如果车型为空
        if (res.data.result.length != 0) {
          // 改造函数结构
          for (let index = 0; index < res.data.result.length; index++) {
            let obj = {text:'',value: '',modelCode:'',gdModelId: '',brandCode:'',brandName:'',oemCode:'' }
            obj.text = res.data.result[index].modelName;
            obj.value = res.data.result[index].gdModelId;
            obj.modelCode = res.data.result[index].modelCode;
            obj.modelName = res.data.result[index].modelName;
            obj.gdModelId = res.data.result[index].gdModelId;
            // 改造后接口
            obj.brandCode = res.data.result[index].brandCode;
            obj.brandName = res.data.result[index].brandName;
            obj.oemCode = res.data.result[index].oemCode;
            arrQ.push(obj)
            // 去掉其他
            if (res.data.result.length === index+1) {
              let obj = {text:'其他',value: '',}
              arrQ.push(obj)
            }
          }
        }
        // 去掉其他  
        else {
          let obj = {text:'其他',value: ''}
          arrQ.push(obj)
        }
        this.carModelValue = '';
        this.carModelOptions = arrQ;
      })
    },
    // 全部选项选择完毕后，会触发 finish 事件
    async onCarModelFinish({selectedOptions}) {
      
      console.log("车型",selectedOptions);
      this.carModelShow = false;
      // this.fieldValue = selectedOptions.map((option) => option.text).join('/');
      this.selectedModelValue = selectedOptions[0].value;
      // console.log("pp",this.fieldValue);
      // let pps = {brandCode:pp}
      this.carModelFieldValue=selectedOptions[0].text;
      
      // 清空车色号
      if(this.dataPar.recipeCollectId){
        console.log("征集配方不清空车色号");
      }else{
        this.fieldValue1 = '';
        this.cascaderValue1 = '';
        this.dataPar.gdColorId = "";
        this.dataPar.colorRgb = "";
        this.dataPar.colorCode = "";
        this.dataPar.colorName = "";
        this.dataPar.colorNum = "";
      }
      
      if(selectedOptions[0].text=="其他"){
        this.Rest.brandName = this.dataPar.carBrandName;
        this.Rest.modelName = "";
        this.dataPar.gdModelId="";
        this.dataPar.carModelCode="";
        this.dataPar.carModelName="";

        this.vehiclePopup = true; 
      }else{
        this.dataPar.gdModelId=selectedOptions[0].gdModelId;
        this.dataPar.carModelCode=selectedOptions[0].modelCode;
        this.dataPar.carModelName=selectedOptions[0].modelName;
        // 信息重新赋值
        this.dataPar.carBrandCode = selectedOptions[0].brandCode;
        this.dataPar.carBrandName = selectedOptions[0].brandName;
        this.dataPar.oemCode = selectedOptions[0].oemCode;

        if(this.dataPar.recipeCollectId){
          console.log("征集配方不清空车色号");
        }else{
          await this.queryColorNumList(this.dataPar.oemCode);
        }
        
      }
      console.log('总数居dataPar',this.dataPar);
    },
    async queryColorNumList(oemCode){
      var pps = {oemCode:oemCode}
      // 色号接口
      await Api.colorNum(pps).then((res) => {
        this.options1 = [];
        if (res.data.result.length === 0) {
          this.fieldValue1 = '';
          // 去掉其他
          this.options1 = [{text:'其他',value: ''}]
        }
        console.log('色号',res);
        // 改造数据结构
        for (let index = 0; index < res.data.result.length; index++) {
          let obj = {text:'',value: '',gdColorId: '',colorRgb: '',colorCode: '',colorName: ''}
          // 没有colorCode的话，不显示
          if (res.data.result[index].colorCode == null) {
            obj.text = res.data.result[index].colorName;
          } else {
            obj.text = res.data.result[index].colorCode + '\u3000\u3000' + res.data.result[index].colorName;
          }
          obj.value = res.data.result[index].gdColorId;
          obj.colorName = res.data.result[index].colorName;
          obj.gdColorId = res.data.result[index].gdColorId;
          obj.colorRgb = res.data.result[index].colorRgb;
          obj.colorCode = res.data.result[index].colorCode;
          this.options1.push(obj)
          // 去掉其他
          if (res.data.result.length === index+1) {
            let obj = {text:'其他',value: ''}
            this.options1.push(obj)
          }
        }
        this.iptValue = '';
      })
    },
    onFinish1({ selectedOptions }) {
      console.log("selectedOptions ",selectedOptions);
      this.show1 = false;
      this.fieldValue1 = selectedOptions.map((option) => option.text).join('/');
      this.cascaderValue1 = selectedOptions[0].value;
      this.dataPar.colorNum = this.fieldValue1;
      console.log("颜色",this.fieldValue1);
      console.log("颜色12",this.cascaderValue1);
      console.log(this.options1.length);

      if (selectedOptions[0].text != '其他') {
        this.dataPar.gdColorId = selectedOptions[0].gdColorId;
        this.dataPar.colorRgb = selectedOptions[0].colorRgb;
        this.dataPar.colorCode = selectedOptions[0].colorCode;
        this.dataPar.colorName = selectedOptions[0].colorName;
        // for (let index = 0; index < this.options1.length; index++) {
        //   if (this.options1[index].value === this.cascaderValue1) {
        //     console.log(this.options1[index].value,this.cascaderValue1);
        //     console.log(this.options1[index]);
        //     this.dataPar.gdColorId = this.options1[index].gdColorId;
        //     this.dataPar.colorRgb = this.options1[index].colorRgb;
        //   }
        // }
      } else {
        console.log("弹出输入色号信息");
        //清空色号信息
        this.dataPar.gdColorId = "";
        this.dataPar.colorRgb = "";
        this.dataPar.colorCode = "";
        this.dataPar.colorName = "";

        this.RestCor.ColorName = "";
        this.RestCor.ColorCode = "";

        //弹出输入色号页面
        this.colorPopup = true;
      }
      
    },
    colCick(val) { 
        if(this.dataPar.recipeCollectId){
          console.log("征集配方油漆品牌不允许选择");
          return false;
        }
        console.log(val);
        this.dataPar.paintColorName = val.brandName;
        this.dataPar.paintColor = val.brandCode;
        this.dataPar.brandUrl = val.brandUrl;
    },
    routeClick() {
      console.log("this.dataPar:",this.dataPar);

      if(!this.dataPar.carBrandName){
        Toast("请填写或选择汽车品牌");
        return;
      }

      if(!this.dataPar.carModelName){
        Toast("请填写或选择车型");
        return;
      }

      if(!this.dataPar.colorName){
        Toast("请填写或选择车色名称");
        return;
      }

      if(!this.dataPar.paintColor){
        Toast("请选择油漆品牌");
        return;
      }
      
      // if (this.dataPar.gdColorId === '' || typeof(this.dataPar.gdColorId) == 'undefined') {
      //   this.dataPar.gdColorId = ''
      // }
      // if (this.dataPar.colorRgb === '' || typeof(this.dataPar.colorRgb) == 'undefined') {
      //   this.dataPar.colorRgb = ''
      // }
      storeStates.addColor = this.dataPar;
      // console.log(this.ppData);
      console.log("end总数居",this.dataPar);
      this.$router.push('/app-h5-cn/page/addColor')
    },
    // 选择汽车品牌的change事件
    optionsChange(val) {
      this.ppData = val;
      let valueShow = true;
      // 车牌品牌code dataPar.carBrandCode
      // 车型code
      this.dataPar.carModelCode = this.cascaderValue;
      // 选择的其他
      if (this.cascaderValue === '') {
        this.cascaderValue = '';
        valueShow = false;
        // 其他弹框显示
        this.vehiclePopup = true;
        this.Rest.brandName = "";
        this.Rest.modelName = "";
       
        // return;
        this.show = false
      }
      // 选择其他时，不运行下面逻辑
      if (valueShow) {
        this.datas.brandCode = this.cascaderValue
        // 响应结果改造
        let arrQ = []
        
        // 请求参数
        let parmas = {
          brandCode:""
        }
        parmas.brandCode = this.cascaderValue
        // 根据品牌,获取车型列表
        Api.vehicleModelList(parmas).then((res) => {
          console.log("车型1",res);
          // 如果车型为空
          if (res.data.result.length != 0) {
            // 改造函数结构
            for (let index = 0; index < res.data.result.length; index++) {
              let obj = {text:'',value: '',modelCode:'',gdModelId: '' }
              obj.text = res.data.result[index].modelName;
              obj.value = res.data.result[index].modelCode;
              obj.modelCode = res.data.result[index].modelCode;
              obj.modelName = res.data.result[index].modelName;
              obj.gdModelId = res.data.result[index].gdModelId;
              arrQ.push(obj)
              // 去掉其他
              if (res.data.result.length === index+1) {
                let obj = {text:'其他',value: '',}
                arrQ.push(obj)
              }
            }
            console.log('321',arrQ);
          }
          // 去掉其他  
          else {
            let obj = {text:'其他',value: ''}
            arrQ.push(obj)
          }

          this.carModelOptions = arrQ;
          // 把改造可用的数据,push到对应的变量里面
          // for (let index = 0; index < this.options.length; index++) {
          //   if (this.options[index].value === this.cascaderValue) {
          //     this.options[index].children = []
          //     this.options[index].children = arrQ
          //     // console.log("arrQ",arrQ);
          //   }
          // }
          
        })
        
      }
      console.log('值',this.cascaderValue);
      console.log("车型X",this.options);
    },
    optionsChange1() {
      console.log("Cor",this.cascaderValue1);
      console.log('arr',this.options1);
      // 查找当前色号的gdColorId
      for (let index = 0; index < this.options1.length; index++) {
        if (this.options1[index].value === this.cascaderValue1) {
          console.log("色号X",this.options1[index]);
          this.dataPar.colorCode = this.options1[index].colorCode;
        }
      }
      
    },

    clickCarModel() {
      console.log(this.dataPar.recipeCollectId);
      console.log(this.collectionRecipe);
      if(this.dataPar.recipeCollectId&&this.dataPar.collectionGdModelId){
        console.log("征集配方车型不允许选择");
        return false;
      }
      if (this.dataPar.carBrandName) {
        this.carModelShow = true;
      } else {
        Toast('请先选择汽车品牌');
      }
    },

    colorSizeClick () {
      if(this.dataPar.recipeCollectId){
        console.log("征集配方车色号不允许选择");
        return false;
      }
      if (this.dataPar.carModelName) {
        this.show1 = true;
      } else {
        Toast('请先选择车型');
      }
    },
    //校验车型品牌是否重复
    checkCarBrandNameRepeat(brandName){
      return new Promise((resolve,reject)=>{
        // 汽车品牌
        Api.vehicleList({brandName:brandName}).then((res) => {
          if(res.data.result.length>0){
            this.customBrandInfo=res.data.result[0];
            console.log(this.customBrandInfo);
            this.customType="brand";
            resolve(true);
          }else{
            resolve(false);
          }
        })
      })
    },
     //校验车型是否重复
    checkCarModelNameRepeat(oemCode,brandCode,modelName){
      return new Promise((resolve,reject)=>{
        // 汽车车型
        Api.carModelListByParam({oemCode:oemCode,brandCode:brandCode,modelName:modelName}).then((res) => {
          if(res.data.result.length>0){
            this.customModelInfo=res.data.result[0];
            console.log(this.customModelInfo);
            this.customType="model";
            resolve(true);
          }else{
            resolve(false);
          }
        })
      });
    },
     //校验色号是否重复
    checkColorCodeRepeat(oemCode,colorName,colorCode){
      return new Promise((resolve,reject)=>{
        // 汽车车型
        Api.colorNum({oemCode:oemCode,colorName:colorName,colorCode:colorCode}).then((res) => {
          if(res.data.result.length>0){
            this.customColorInfo=res.data.result[0];
            console.log(this.customColorInfo);
            this.customType="color";
            resolve(true);
          }else{
            resolve(false);
          }
        })
      });
    },
    async affClick(val) {
      console.log(val);
      if (val === 'type1') {
        if(!this.Rest.brandName){
          Toast.fail("请填写汽车品牌");
          return;
        }

        if(!this.Rest.modelName){
          Toast.fail("请填写车型");
          return;
        }
        if(!this.dataPar.oemCode){
          //校验车型品牌名称是否重复
          if(await this.checkCarBrandNameRepeat(this.Rest.brandName)===true){
            // Toast.fail("您输入的品牌已存在，您可以在品牌列表中直接选择，谢谢！");
            // Toast({
            //   message: '您输入的品牌已存在，\n请在列表中直接选择.',
            // });
            this.vehiclePopup = false;
            this.dialogPrompt="您输入的品牌已存在，\n请在列表中直接选择.";
            this.dialogShow=true;
            
            return;
          }
        }

        if(this.dataPar.oemCode){
          //校验车型名称是否重复
          if(await this.checkCarModelNameRepeat(this.dataPar.oemCode,this.dataPar.carBrandCode,this.Rest.modelName)===true){
            // Toast.fail("您输入的车型已存在，您可以在车型列表中直接选择，谢谢！");
            // Toast({
            //   className:"toast-class",
            //   message:'您输入的车型已存在，\n请在列表中直接选择.'
            // });
            this.vehiclePopup = false;
            this.dialogPrompt="您输入的车型已存在，\n请在列表中直接选择";
            this.dialogShow=true;
            
            return;
          }
        }
        // 处理
        this.fieldValue = this.Rest.brandName+'/'+this.Rest.modelName;
        this.vehiclePopup = false;
        // 去掉其他
        if (this.options1.length === 0) {
          let obj = {text:'其他',value: ''}
          this.options1.push(obj)
        }
        // 车品牌，车型赋值
        this.dataPar.vehicle = this.fieldValue;
        // 色后
        this.dataPar.colorNum = this.fieldValue1;
        this.dataPar.carBrandName = this.Rest.brandName;
        this.dataPar.carModelName = this.Rest.modelName;
        this.show = false;
      } else if(val === 'type2') {
        if(!this.RestCor.ColorName){
          Toast.fail("请输入车色名称");
          return;
        }
        if(this.dataPar.oemCode){
          //校验车车号是否重复
          if(await this.checkColorCodeRepeat(this.dataPar.oemCode,this.RestCor.ColorName,this.RestCor.ColorCode)===true){
            // Toast.fail("您输入的色号已存在，您可以在色号列表中直接选择，谢谢！");
            // Toast({
            //   message: '您输入的色号已存在，\n请在列表中直接选择.',
            // });
            this.colorPopup=false;
            this.dialogPrompt="您输入的色号已存在，\n请在列表中直接选择.";
            this.dialogShow=true;
            
            return;
          }
        }
        // 处理
        this.fieldValue1 = this.RestCor.ColorCode+' '+ this.RestCor.ColorName;
        this.colorPopup = false;
        // 车品牌，车型赋值
        this.dataPar.vehicle = this.fieldValue;
        // 色号
        this.dataPar.colorNum = this.fieldValue1;

        this.dataPar.colorName = this.RestCor.ColorName;
        this.dataPar.colorCode = this.RestCor.ColorCode;
        this.show = false;
      }
      
    },
    closeModel(type) {
      console.log("type:",type);
      if(type=="color"){
        this.cascaderValue1 = "";
      }else if(type=="car"){
        this.cascaderValue = "";
      }
    },
    closeClick() {
      this.carBrandShow = false;
      this.show1 = false;
      this.carModelShow = false;
      document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
    },
    confirmOpen() {
      console.log(this.customType);
      this.dialogShow=false;
      if(this.customType=="brand"){
        this.carBrandValue=this.customBrandInfo.brandName;
        this.openCarBrandModel();
      }else if(this.customType=="model"){
        this.carModelValue=this.customModelInfo.modelName;
        this.clickCarModel();
      }else if(this.customType=="color"){
        this.iptValue=this.customColorInfo.colorName;
        this.colorSizeClick();
      }
     
    },
    cancelOpen() {
      this.dialogShow=false;
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
    background-color: white;
    width: 100%;
    height: 100vh;
}
.popup-style {
  .cascader-input-style {
      position: absolute;
      width: 100%;
      height: 50px;
      margin-top: 40px;
      padding: 20px 0px;
      /deep/ .van-field__body {
        height: 100%;
      }
      /deep/ .van-field__control {
        font-size: 14px;
        font-weight: 300;
        color: black;
      }
      /deep/ .van-field__left-icon .van-icon, .van-field__right-icon .van-icon {
        margin-top: 6px;
      }
  }
  /deep/ .van-tabs--line .van-tabs__wrap {
    margin-top: 39px;
  }
}

.box-back {
    width: 100%;
    height: 10px;
    background-color: rgb(243,243,249);
}
.box-btn {
    width: 100%;
    position: fixed;
    display: flex;
    justify-content: center;
    bottom: 90px;
}
.col-div {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    
    .div-cell {
        width: 148px;
        height: 25px;
        margin-top: 8px;
        border-radius: 15px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: solid 1px rgb(235,235,235);
        background-color: rgb(235,235,235);
    }
}
.vehiclePopupBox {
  width: 100%;
  height: 100%;
  padding:10px;
  background-color: rgb(241,241,241);
}
.pupo-style {
  font-size: 13px;
  font-weight: 600;
}
.input-style {
  color: inherit;
    height: 30px;
    font: inherit;
    border: solid 1px #fff;
    border-radius: 5px;
    width: 100%;
}
/deep/ .van-cell {
    font-size: 13px;
    font-weight: 300;
    color: #646566;
}
/deep/ .van-field__label {
    font-size: 13px;
    font-weight: 300;
}
/deep/ .van-field__control {
    font-size: 13px;
    font-weight: 300;
    color: rgb(155, 155, 155);
}
/deep/ .van-button--round {
    width: 200px;
}
/deep/ .van-popup--center {
  width: 66%;
  background-color: rgb(241,241,241);
}
.tab-style {
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
.box1 {
  margin-top: 2.9rem;
}
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}

.footer-fixed {
  padding: 5px 0px 0px;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
}

.save_button {
  width: 210px;
  height: 50px;
  background: #53565a;
  border-radius: 4px;
  border: none;
}
.stepper-div-btn {
    box-sizing: border-box;
    width: 90%;
    height: 2rem;
    margin: -10px 5%;
    padding: 2px 7px;
    color: #323233;
    font-size: 14px;
    line-height: normal;
    // text-align: center;
    // vertical-align: middle;
    background-color: rgb(243,242,249);
    border: 0;
    border-radius: 15px;
    -webkit-appearance: none;
  }
/deep/ .van-action-sheet .model-btn {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    justify-content: center;
}
/deep/ .van-toast{
  width:80% !important;
}
/deep/  .toast-class{
  width:80% !important;
}

/deep/ .van-toast--html, .van-toast--text{
  width:80% !important;
  min-width:60% !important;
}

// /deep/ .van-hairline--bottom::after {
//   border-bottom-width: 0px;
// }

</style>